/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerHolderDetailConfig } from '../../config/header.config';
export interface IHeaderHolderDetailPluginMethods extends IPluginMethodMap {
  getHeaderHolderDetailSync(args?: any): any;
}

export class HeaderHolderDetailPlugin implements IAgentPlugin {
  readonly methods: IHeaderHolderDetailPluginMethods;

  constructor() {
    this.methods = {
      getHeaderHolderDetailSync: this.getHeaderHolderDetailSync.bind(this),
    };
  }

  getHeaderHolderDetailSync(args?: any) {
    return {
      header: headerHolderDetailConfig,
    };
  }
}
